<div class="diagram" [ngClass]="{'inFilter':filterRecipients!=undefined,'compare':showComparison$(),'wasChange':wasChange}"
    [style.background]="'linear-gradient(to right, #DCE1ED ' + percentage + '%, transparent ' + percentage + '%)'">
    <p>{{value}}</p>
    <p class="prec" *ngIf="filterRecipients==undefined">{{percentage}}%</p>
</div>